export { default as UniversalImage } from './UniversalImage'
export type { UniversalImageProps } from './UniversalImage'


